var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcessorCluster = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 54 54"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27,
  r: 26,
  fill: "#00BCD4",
  stroke: "#fff",
  strokeWidth: 2
})));
export { SvgProcessorCluster as ReactComponent };
export default __webpack_public_path__ + "static/media/processor-cluster.c77fe0e4.svg";